(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.search = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.findFirstNode = findFirstNode;
    exports.mapPathToData = mapPathToData;
    function findOrdinalPaths(nodes, childrenPropertyName, predicate, depth, path, paths) {
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            var childNodes = node[childrenPropertyName];

            path[depth] = i;

            if (predicate(node)) {
                path.splice(depth + 1);
                paths.push(path.join());
            }

            if (childNodes.length) {
                findOrdinalPaths(childNodes, childrenPropertyName, predicate, depth + 1, path, paths);
            }
        }

        return paths;
    }

    function find(nodes, predicate, childrenPropertyName) {
        return findOrdinalPaths(nodes, childrenPropertyName, predicate, 0, [], []);
    }

    function normalizeData(data) {
        if (!Array.isArray(data)) {
            return [data];
        }

        return data;
    }

    function _mapPathToData(data, childrenPropertyName, path, predicate, depth, currentPath, out) {
        var p = path.split(',').slice(0, depth + 1).join();

        data = normalizeData(data);

        for (var i = 0; i < data.length; i++) {
            var node = data[i];
            var children = node[childrenPropertyName];

            if (!children) {
                throw new Error('Supplied value for prop `childrenPropertyName`, ' + childrenPropertyName + ', was not found in at least one node of your data!');
            }

            currentPath[depth] = i;
            var cp = currentPath.slice(0, depth + 1).join();

            if (cp === p) {
                out[depth] = predicate(node);
            }

            if (children.length) {
                _mapPathToData(children, childrenPropertyName, path, predicate, depth + 1, currentPath, out);
            }
        }

        return out;
    }

    function findFirstNode(nodes, predicate, childrenPropertyName) {
        var paths = find(nodes, predicate, childrenPropertyName);
        return paths.length ? paths[0] : '';
    }

    function mapPathToData(data, childrenPropertyName, path, predicate) {
        return _mapPathToData(data, childrenPropertyName, path, predicate, 0, [], []);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-lazy-tree/dist/search.js
// module id = 374
// module chunks = 0